import React from 'react';
import { useTranslation } from 'react-i18next';

import { ModalDialog, Button } from '@mssgme/ui';

export default function UpdateDialog(props) {
    const { t } = useTranslation();

    async function onClick(e) {
        e.preventDefault();
        window.location.reload();
    }

    return (
        <ModalDialog {...props} title={t('UpdateDialog.heading')} modal={{ size: 'small' }}>
            <p>{t('UpdateDialog.content')}</p>
            <p>
                <Button fullWidth onClick={onClick}>
                    {t('UpdateDialog.update')}
                </Button>
            </p>
        </ModalDialog>
    );
}
